import { Link } from 'react-router';
import { Mail } from 'lucide-react';

export const MarketingFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full border-t bg-gray-50 pb-24 md:pb-8">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Column */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex items-center gap-2 font-bold text-xl">
              <img
                src="/assets/peetrack_logo.png"
                alt="PeeTrack Logo"
                className="h-8 w-8 object-contain"
              />
              <span className="text-gray-900">PeeTrack</span>
            </Link>
            <p className="text-sm text-gray-600">
              AI-powered fluid intake and output tracking
            </p>
          </div>

          {/* Quick Links Column */}
          <div className="flex flex-col gap-4">
            <h3 className="font-semibold text-gray-900">Legal</h3>
            <Link
              to="/privacy"
              className="text-sm text-gray-600 hover:text-cyan-600 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-gray-600 hover:text-cyan-600 transition-colors"
            >
              Terms of Service
            </Link>
          </div>

          {/* Contact Column */}
          <div className="flex flex-col gap-4">
            <h3 className="font-semibold text-gray-900">Connect</h3>
            <a
              href="mailto:support@peetrack.live"
              className="flex items-center gap-2 text-sm text-gray-600 hover:text-cyan-600 transition-colors"
            >
              <Mail className="h-4 w-4" />
              Support
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-center text-gray-600">
            © {currentYear} PeeTrack. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
